import React from 'react';

import { flagStyles } from '../settings';

const SvgKE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2712px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKE;
